export const RESTRICAO_CLIENTE_CREATE = "RESTRICAO_CLIENTE_CREATE";
export const RESTRICAO_CLIENTE_CREATE_ALL = "RESTRICAO_CLIENTE_CREATE_ALL";
export const RESTRICAO_CLIENTE_LOAD_CLIENTS = "RESTRICAO_CLIENTE_LOAD_CLIENTS";
export const RESTRICAO_CLIENTE_LOAD_PRODUCTS =
  "RESTRICAO_CLIENTE_LOAD_PRODUCTS";
export const RESTRICAO_CLIENTE_REMOVE = "RESTRICAO_CLIENTE_REMOVE";
